import React, { createContext } from "react";
import { useEffect } from "react";
import { getData } from "../services/API";
import { useState } from "react";
import { getItemStorage } from "../Localstorage/useLocalStorage";

export const ResumeDataContext = createContext();

const ResumeContext = ({ children }) => {
  const [resume, setResume] = useState([]);

  useEffect(() => {}, [resume]);

  return (
    <ResumeDataContext.Provider value={{ resume, setResume }}>
      {children}
    </ResumeDataContext.Provider>
  );
};

export default ResumeContext;
